module.exports = "<div>\n  <span>Brian</span>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/element-child.js
 ** module id = 278
 ** module chunks = 0
 **/